import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import type { IErrorNotificationProps } from './ErrorNotification';
import { ErrorNotification } from './ErrorNotification';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey[100],
    },
}));

export const InfoNotification: React.FC<IErrorNotificationProps> = (props) => {
    const classes = useStyles();
    return (
        <Box className={classes.container}>
            <ErrorNotification {...props} />
        </Box>
    );
};
